export default __webpack_public_path__ + "static/media/Swiss721BTBold.bae5e83f.woff2";